module.exports = __webpack_public_path__ + "static/media/5.e4c61299.jpg";